import { render, staticRenderFns } from "./FileHistory.vue?vue&type=template&id=6a40c772&"
import script from "./FileHistory.vue?vue&type=script&lang=js&"
export * from "./FileHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports